import { createFileRoute } from "@tanstack/react-router";
import { AdminTradeDetailView } from "./-components/admin-trade-detail-view";

export const Route = createFileRoute(
  "/(app)/_admin-layout/admin_/fx_/trades_/$tradeId",
)({
  component: AdminTradeDetailPage,
});

function AdminTradeDetailPage() {
  const { tradeId } = Route.useParams();
  const context = Route.useRouteContext();
  return (
    <AdminTradeDetailView tradeId={tradeId} accessToken={context.accessToken} />
  );
}
